import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import {ToastrService} from "ngx-toastr";
import * as moment from "moment/moment";
import {RequestTypeService} from "@appServices/core-ticketing/request-type.service";
import {RequestTypeListRow} from "@appModels/ticketing/request-type-list-row";

@Component({
  moduleId: module.id,
  templateUrl: './request-type-table.component.html',
  animations: [
    trigger('toggleAnimation', [
      transition(':enter', [style({ opacity: 0, transform: 'scale(0.95)' }), animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))]),
      transition(':leave', [animate('75ms', style({ opacity: 0, transform: 'scale(0.95)' }))]),
    ]),
  ],
  styleUrls: ['./request-type-table.component.css', '../../../tailwind.css']
})
export class RequestTypeTableComponent {
  constructor(
    private toastrService: ToastrService,
    private ref: ChangeDetectorRef,
    private issueTypeService: RequestTypeService
  ) {
    this.getRequestTypes();
  }

  loadingTable = true;
  dateFormat = moment().format('YYYY-MM-DD hh:mm:ss');
  moment: any = moment;

  getRequestTypes() {
    this.issueTypeService.getRequestTypes(true).subscribe(x=> {
      this.requestTypes = x;
      this.loadingTable = false;
    })
  }

  requestTypes : RequestTypeListRow[] = [];

}
